import { css } from '@emotion/react';

export const iconsWrapper = (spaceX: string, spaceY: string) => css`
  display: flex;
  gap: ${spaceX}px;
  margin-top: ${spaceY}px;
  flex-wrap: wrap;
`;
